import { render, staticRenderFns } from "./TheActivateView.vue?vue&type=template&id=6b5f7fe0"
import script from "./TheActivateView.vue?vue&type=script&lang=js"
export * from "./TheActivateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports